export const personalDataMemberValidationRules = {
    firstName: {
        isRequiredTrim: {
            value: true,
        },
    },
    lastName: {
        isRequiredTrim: {
            value: true,
        },
    },
    phoneNumber: {
        isRequiredTrim: {
            value: true,
        },
    },
    emailAddress: {
        isRequiredTrim: {
            value: true,
        },
        regex: {
            value: {
                pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
                customMessageKey: "validation.emailRegex",
            },
        },
    },
    birthdate: {
        isRequiredTrim: {
            value: true,
        },
    },
    gRecaptchaResponse: {
        isRequiredTrim: {
            value: true,
        },
    },
    address: {
        isRequiredTrim: {
            value: true,
        },
    },
    city: {
        isRequiredTrim: {
            value: true,
        },
        regex: {
            value: {
                pattern: /[a-zA-Z ]/i,
                customMessageKey:"validation.cityRegex"
            },
        },
    },
    provinceCode: {
        isRequiredTrim: {
            value: true,
        },
    },
    postalCode: {
        isRequiredTrim: {
            value: true,
        },
    },
    countryCode: {
        isRequiredTrim: {
            value: true,
        },
    },
    legalText: {
        isRequiredTrim: {
            value: true,
            customMessageKey: "validation.legalTextCheckBoxValidation"
        },
    },
    legalTextIdentity: {
        isRequiredTrim: {
            value: true,
            customMessageKey: "validation.legalTextCheckBoxValidation"
        },
    },
    legalTextDataUsage: {
        isRequiredTrim: {
            value: true,
            customMessageKey: "validation.legalTextCheckBoxValidation"
        },
    },
    legalTextDelay: {
        isRequiredTrim: {
            value: true,
            customMessageKey: "validation.legalTextCheckBoxValidation"
        },
    },
    languageCode: {
        isRequiredTrim: {
            value: true,
        },
    },
    memberGenderType: {
        isRequiredTrim: {
            value: true,
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/personal-data/personalDataMemberValidationRules.js